import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Event } from 'src/app/shared/models/event.module';
import { environment } from 'src/environments/environment';

export class EventType {
  id: number;
  name_it: string;
  name_de: string;
  name_en: string;
  status: number;
}

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  constructor(private _http: HttpClient) { }

  public getOrganizationEvents(orgId: string, eventId?: number): Observable<Event[] | Event> {
    let paramas = new HttpParams();
    paramas = paramas.append('id', orgId);
    // VssOrganization
    return this._http.get<Event[]>(environment.serverUrl + 'event/get', {
      params: paramas,
    }).pipe(
      map(responseData => {
        return (!eventId ? responseData : responseData.filter(r => r.id.toString() === eventId.toString())[0]);
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public updateOrganizationEvent(event: Event): Observable<any> {
    return this._http.post<any>(environment.serverUrl + 'event/update', { event }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public createOrganizationEvent(event: Event): Observable<any> {
    return this._http.put<any>(environment.serverUrl + 'event/create', { event }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  /**
   * submitOrganizationImage
   */
  public submitEventImage(file: File, orgId: number) {
    const formData = new FormData();
    formData.append('id', orgId.toString());
    formData.append('image', file, file.name);
    return this._http.post<any>(
      environment.serverUrl + 'event/upload',
      formData
    ).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public getEventTypes(): Observable<EventType[]> {
    return this._http.get<EventType[]>(environment.serverUrl + 'eventType/get').pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public deleteEvent(eventId: number) {
    let paramas = new HttpParams();
    paramas = paramas.append('id', eventId.toString());
    return this._http.delete<void>(environment.serverUrl + 'event/delete', {
      params: paramas,
    }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public deleteEventImage(imageId: number) {
    let paramas = new HttpParams();
    paramas = paramas.append('id', imageId.toString());
    return this._http.delete<void>(environment.serverUrl + 'event/deleteFile', {
      params: paramas,
    }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }
  public setMainEventImage(id: number): Observable<any> {
    return this._http.post<any>(environment.serverUrl + 'event/mainImage', { id }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }
}
